// THIS FILE IS AUTOGENERATED, EDIT WITH CAUTION
import {Editor} from '@karma.run/editor-client'
import config from '../editor.client.config.ts'

const editor = new Editor(config)
editor.attach()